import React from 'react'
import PropTypes from 'prop-types'
import { Flyout } from '@zambezi/sdk/flyout'
import { Icon } from '@zambezi/sdk/icons'
import { classNames, useGlobalId } from '@zambezi/sdk/common'

/**
 * @type {React.FunctionComponent<import('./interfaces').ErrorProps>}
 * @param {import('./interfaces').ErrorProps} props
 */
export default function ErrorMessage (props) {
  const id = useGlobalId('zb-formidable-error-')
  const options = {
    id,
    arrowDirection: 'top',
    arrowPosition: '16px',
    align: 'left',
    iconName: 'error-small',
    iconSize: 'small',
    ...props
  }

  const errorIcon = options.showIconInError ? (
    <Icon
      name={options.iconName}
      title='Error'
      size={options.iconSize}
      className='zb-formidable-error-icon'
    />
  ) : null

  const className = classNames(
    options.className,
    'zb-formidable-error',
    options.arrowDirection
      ? `zb-formidable-error-is-${options.arrowDirection}`
      : null,
    options.align ? `zb-formidable-error-align-is-${options.align}` : null,
    errorIcon ? 'zb-formidable-error-with-icon' : null
  )

  return (
    <Flyout isError isShown {...options} className={className}>
      {errorIcon}
      {props.children}
    </Flyout>
  )
}

ErrorMessage.propTypes = {
  arrowDirection: Flyout.propTypes.arrowDirection,
  arrowPosition: Flyout.propTypes.arrowPosition,
  align: PropTypes.oneOf(['left', 'right', 'center']),
  showErrorInLabel: PropTypes.bool,
  showIconInError: PropTypes.bool,
  iconName: PropTypes.string,
  iconSize: PropTypes.string
}
